<template>
  <div class="app-wrapper">
    <nav-menu></nav-menu>
    <div class="main-container">
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
import AppMain from "./components/AppMain";
import NavMenu from "@/components/layout/navMenu.vue";

export default {
  name: "layout",
  components: {
    AppMain,
    NavMenu,
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  min-width: 1080px;
  background-color: #f5f7fa;
  display: flex;
  padding: 10px 14px 10px 20px;
  box-sizing: border-box;
  .main-container {
    flex: 1;
    min-height: 100%;
    max-height: 100vh;
    padding-left: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
}
</style>
